// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@guestsupply/Overrides/Widgets/Budget/ConfigureBudget";
import { color, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import XCircle from "@insite/mobius/Icons/XCircle";
import { RadioGroupStyle } from "@insite/mobius/RadioGroup";
import { css } from "styled-components";

configureBudgetStyles.gridContainer = {
    gap: 0,
};

configureBudgetStyles.startDatePicker = {
    cssOverrides: {
        datePicker: css`
            max-width: 134px;
            .react-datetime-picker__calendar {
                z-index: 1263;
            }
        `,
    },
};

configureBudgetStyles.budgetYearGridItem = {
    width: 12,
    css: css`
        padding-top: 7px;
        padding-bottom: 0;
    `,
};
// XNG-Changes: GSS-353
configureBudgetStyles.budgetYearEndGridItem = {
    width: 12,
    css: css`
        display: flex;
        align-items: flex-end;
        padding: 9px 0 8px;
        ${xScreen("lte", "sm")} {
            display: block;
            padding-bottom: 10px;
        }
        ${xScreen("gt", "md")} {
            ${RadioGroupStyle} legend {
                margin-bottom: 0;
            }
        }
    `,
};

configureBudgetStyles.budgetPeriodTitle = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin: 0 6px 0 0;
    `,
};
// XNG-Changes: GSS-353
configureBudgetStyles.gridItems = {
    css: css`
        align-items: flex-end;
        padding: 11px 0;
    `,
};

configureBudgetStyles.titleGridItems = {
    width: [12, 7, 8, 8, 8],
    css: css`
        align-items: center;
        padding: 20px 0 15px;
    `,
};

configureBudgetStyles.titleText = {
    variant: "h2",
};

configureBudgetStyles.customBudgetPeriodInput = {
    type: "number",
    min: 1,
    max: 13,
    cssOverrides: {
        formField: css`
            width: 55px;
            display: inline-block !important;
            margin-right: 20px;
            margin-top: 10px;
        `,
        inputSelect: css`
            padding-right: 5px;
            &:focus {
                padding-right: 5px;
            }
        `,
    },
};

configureBudgetStyles.buttonsGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        padding: 20px 0 15px;
        ${xScreen("lte", "xs")} {
            padding-top: 0;
        }
    `,
};

configureBudgetStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-top: 2px;
        ${xScreen("lte", "xs")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

configureBudgetStyles.saveButton = {
    css: css`
        margin-left: 10px;
        margin-top: 2px;
        ${xScreen("lte", "xs")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

configureBudgetStyles.enforcementLevelGridItems = {
    width: 12,
    css: css`
        display: block;
        padding-bottom: 8px;
        ${xScreen("lte", "xs")} {
            padding-top: 10px;
        }
    `,
};
// XNG-Changes: GSS-353
configureBudgetStyles.enforcementLevelLabel = {
    variant: "h5",
    css: css`
        display: inline-block;
        align-self: flex-end;
        margin-right: 6px;
        margin-bottom: 0;
    `,
};

// XNG-Changes: GSS-353
configureBudgetStyles.tableGridItems = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding: 15px 0 8px;
        & > div {
            overflow-y: unset;
            overflow-x: unset;
        }
        ${xScreen("lte", "xs")} {
            padding: 15px 0;
        }
    `,
};

configureBudgetStyles.buttonsHidden = {
    css: css`
        width: 100%;
        display: flex;
        ${xScreen("lte", "xs")} {
            padding-top: 15px;
        }
    `,
};

// XNG-Changes: GSS-353
configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        formField: css`
            width: auto;
            margin-right: 35px;
            ${xScreen("lte", "sm")} {
                margin-top: 15px;
                margin-bottom: 5px;
            }
        `,
        datePicker: css`
            .react-datetime-picker__calendar {
                z-index: 1263;
            }
            &:not(:disabled),
            &:focus-within {
                padding: 0;
                .react-datetime-picker__clear-button {
                    display: block !important;
                }
            }
        `,
    },
};
// XNG-Changes: GSS-353
configureBudgetStyles.enforcementLevel = {
    css: css`
        display: flex;
        align-items: baseline;
    `,
};
// XNG-Changes: GSS-353
configureBudgetStyles.removeCells = {
    css: css`
        vertical-align: middle;
    `,
};
// XNG-Changes: GSS-353
configureBudgetStyles.clearDatePicker = {
    size: 18,
    css: css`
        color: ${color("primary")};
        vertical-align: middle;
    `,
};
// XNG-Changes: GSS-353
configureBudgetStyles.twoButtonModalStyles = {
    ...mergeToNew(configureBudgetStyles.twoButtonModalStyles, {
        modal: {
            sizeVariant: "medium",
        },
    }),
};

configureBudgetStyles.dataTable = {
    css: css`
        overflow: auto;
    `,
};

configureBudgetStyles.removeIcon = {
    src: XCircle,
    css: css`
        display: block;
        cursor: pointer;
        margin: auto;
        &:hover {
            color: ${color("primary")};
        }
    `,
};
